/* eslint-disable @typescript-eslint/no-explicit-any */

import * as React from 'react'
import Box from '@mui/material/Box'
import Campaign from 'src/components/pages/campaign'
import { apiFetch } from '../service/api.service'

interface IProps {
  data: any
  isLoading: boolean
}
export default function Home({ data, isLoading }: IProps) {
  return (
    <Box component="div">
      <Campaign data={data} isLoading={isLoading} />
    </Box>
  )
}
export async function getServerSideProps() {
  // Fetch data from external API
  const baseURL =
    process.env.NEXT_PUBLIC_BACKEND_URL ||
    'https://strapi-beta.ditchthelabel.org'
  const endPoint =
    process.env.NEXT_PUBLIC_SITE_LANGUAGE === 'en'
      ? `/api/article-schemas?filters[name][$eq]=campaigns&populate=deep`
      : `/api/article-schemas?filters[name][$eq]=mx-campaigns&populate=deep&locale=es-MX`
  const url = baseURL + endPoint
  let isLoading = true

  const data = await apiFetch(url)

  isLoading = false

  // Pass data to the page via props
  return { props: { data, isLoading } }
}
